module.exports = __webpack_public_path__ + "static/media/charge.f4354025.svg";